import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const navLinks = [
    { to: "/Home", label: "Home" },
    { to: "/HowItWorks", label: "How It Works" },
    { to: "/Stack", label: "Stack" },
    { to: "/Tokenomics", label: "Tokenomics" },
    { to: "/Roadmap", label: "Roadmap" },
    { to: "/Mission-Vision", label: "Mission & Vision" },
    { to: "/Dashboard", label: "Dashboard" },
    { to: "/Blog", label: "Blog" },
    { to: "/Contact", label: "Contact" },
  ];

  return (
    <nav className="relative">
      {/* Mobile burger button (LEFT) */}
      <button
        onClick={() => setMenuOpen(true)}
        className={`relative text-2xl p-2 md:hidden transition-transform ${
          menuOpen
            ? "text-[var(--color-primary-light)] scale-110"
            : "hover:text-[var(--color-primary)] hover:scale-105"
        }`}
        aria-label="Open menu"
      >
        ☰
      </button>

      {/* Mobile slide-in menu from LEFT */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            key="mobile-menu"
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ type: "tween", duration: 0.3 }}
            className="fixed top-0 left-0 w-3/4 max-w-xs h-screen bg-[var(--color-secondary-dark)] z-50 shadow-xl flex flex-col"
          >
            {/* Top section */}
            <div className="flex justify-between items-center p-4 border-b border-[var(--color-secondary-muted)]">
              <h2 className="text-lg font-bold text-white">Menu</h2>
              <button
                onClick={() => setMenuOpen(false)}
                aria-label="Close menu"
                className="text-2xl text-white hover:text-[var(--color-primary-light)]"
              >
                ✕
              </button>
            </div>

            {/* Navigation Links */}
            <ul className="flex flex-col px-4 py-6 gap-2">
              {navLinks.map(({ to, label }, index) => (
                <li
                  key={index}
                  className="border-b border-[var(--color-secondary-muted)]"
                >
                  <Link
                    to={to}
                    onClick={() => setMenuOpen(false)}
                    className="block py-3 text-base font-bold text-white hover:text-[var(--color-primary-light)] transition"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Desktop nav */}
      <ul className="hidden md:flex gap-2 relative">
        {navLinks.map(({ to, label }, index) => {
          const isActive = currentPath === to;

          return (
            <li key={index} className="relative">
              <Link
                to={to}
                className={`relative text-base font-bold px-2 py-2 transition z-10 ${
                  isActive ? "text-white" : "hover:text-[var(--color-primary)]"
                }`}
              >
                {/* Highlight for active link */}
                {isActive && (
                  <motion.div
                    layoutId="nav-highlight"
                    className="absolute inset-0 bg-[var(--color-primary)] z-[-1] "
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                  />
                )}
                {label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Nav;
